import axiosInstance from "../config/axiosConfig";

export const fetchNoticias = async () => {
  const params = {
    tipo: 'E'
  }
  return await axiosInstance.get("noticias/listar-noticias", {params});
};
